// extracted by mini-css-extract-plugin
module.exports = {"bold":"styles_bold__3cpA9","offset":"styles_offset__2ac1W","currentPaymentMethod":"styles_currentPaymentMethod__1dwlW","header":"styles_header__bpA_g"};